/**
 * Show search results as they type https://shopify.dev/docs/api/ajax/reference/predictive-search
 * https://empire-bmx.myshopify.com/search/suggest.json?q=bike
 */

document.addEventListener('DOMContentLoaded', function () {
    var searchInput = document.getElementById('search-input');
    var searchResults = document.getElementById('search-results');

    searchInput.addEventListener('input', function () {
        var query = searchInput.value;

        if (query.length > 0) {
            performSearch(query);
        } else {
            clearResults();
        }
    });

    function performSearch(query) {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query))
            .then((response) => response.json())
            .then((suggestions) => {
                const productSuggestions = suggestions.resources.results.products;
                // console.log('productSuggestions', productSuggestions);
                if (productSuggestions.length > 0) {
                    const firstProductSuggestion = productSuggestions[0];

                    // console.log(`The title of the first product suggestion is: ${firstProductSuggestion.title}`);
                }
                displayResults(suggestions.resources.results.products);
            })
            .catch(function (error) {
                console.error('An error occurred:', error);
            });
    }

    function displayResults(results) {
        searchResults.innerHTML = '';
        // console.log(results)
        results.forEach(function (result) {
            var li = document.createElement('li');
            li.textContent = result.title;
            searchResults.appendChild(li);
        });
    }

    function clearResults() {
        searchResults.innerHTML = '';
    }
});